import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withHashLocation } from '@angular/router';
import Aura from '@primeng/themes/aura';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

import { appRoutes } from './app.routes';
import { UniquErrorInterceptor } from './errors/interceptors/unique-field-interceptor';
import { JwtInterceptor } from './modules/auth/interceptors/jwt.interceptor';
import { UnauthorisedInterceptor } from './modules/auth/interceptors/unauthorised.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withHashLocation()),
    MessageService,
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: Aura,
      },
    }),
    ConfirmationService,
    provideHttpClient(
      withInterceptors([
        JwtInterceptor,
        UnauthorisedInterceptor,
        UniquErrorInterceptor,
      ])
    ),
  ],
};
